export class Nota {
    public idcompania: string;
    public idNota: string;
    public descripcion: string;
    public idPunto: string;
    public idVisita: string;
    public idTareas: string;
    public imagen: string;
    public longitud: string;
    public latitud: string;

}